// export const ApiUrl="http://localhost:5075/api/"
export const ApiUrl="https://api.salestern.com/api/"
